import RecruiterStatsProgressChart from 'components/charts/RecruiterStatsProgressChart';
import React from 'react';
import { Card, CardBody } from 'react-bootstrap';
import { Props } from './statsCard.type';
import { formatNumber } from 'helpers/number-utils';

function StatsCard({ value, label, rate, type }: Props) {
  return (
    <Card>
      <CardBody className="d-flex justify-content-between pe-2 align-items-center">
        <div>
          <h5 className="text-body-tertiary">{label}</h5>
          <p className="fs-4 m-0 fw-bold ">{formatNumber(value)}</p>
        </div>
        <div>
          <RecruiterStatsProgressChart value={rate} type={type} />
        </div>
      </CardBody>
    </Card>
  );
}

export default StatsCard;
